import { render, staticRenderFns } from "./ProductFilters.vue?vue&type=template&id=3b127240"
import script from "./ProductFilters.ts?vue&type=script&lang=ts&external"
export * from "./ProductFilters.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports